import "./style.scss";

import Button from "shared/ui/Button";
import { Button_Style } from "shared/ui/Button/Button";
import React, { FC } from "react";
import FileUploader from "components/FileUploader";
import MultipleSelect from "shared/ui/MultipleSelect";
import Input from "shared/ui/Input";


const options2 = [
  { value: '1 procès verbal de plainte', label: '1 procès verbal de plainte' },
  { value: '1 main courante', label: '1 main courante' },
  { value: '1 récapitulatif de signalement sur la plateforme thésée', label: '1 récapitulatif de signalement sur la plateforme thésée' },
  { value: 'ma plainte a été refusée', label: 'ma plainte a été refusée' },
]


interface IDAssistantUploadPVProps {
    steps: any;
    setDatas: (data: any) => void;
    datas: any;
    handlePreviousStep: () => void;
    handleNextStep: () => void;
}
const IDAssistantUploadPV: FC<IDAssistantUploadPVProps> = ({ steps, setDatas, datas, handleNextStep, handlePreviousStep }) => {

  const handleFileRemoval = (file: File) => {
    const updatedFiles = datas.filesToUpload.filter((selectedFile: any) => selectedFile !== file);
    setDatas({ ...datas, filesToUpload: updatedFiles })
  };

  return (
        <div className="IDAssistantUploadPV  w-100 h-100 d-flex flex-column align-items-center justify-content-between">
          <div>
            <h3>Votre pv déclaration de perte et / ou dépôt de plainte</h3>

            <p className="">
              Ce document est nécessaire pour lancer les démarches mais vous pouvez l'ajouter à votre dossier
              ultérieurement.
            </p>

            <MultipleSelect
              options={options2}
              closeMenuOnSelect={true}
              label={"Justificatifs"}
              placeholder={"choisir le type de justificatif"}
              className={"mt-1 mb-1"}
              value={datas.plaintesRaisons}
              onChange={(value: any) => setDatas({ ...datas, plaintesRaisons: value })}
            />

            {!datas.plaintesRaisons.includes(options2[3]) && (
              <FileUploader
                onChange={(files) => setDatas({ ...datas, filesToUpload: files })}
                onDelete={handleFileRemoval}
                fileLimit={1}
                maxFileSize={12}
                selectFiles={datas.filesToUpload?.length >= 1 ? [datas.filesToUpload[0]] : []}
                allowedFormats={"image/jpeg, image/png, application/pdf"}
              />
            )}

            <Input
              onChange={(value)=> {setDatas({ ...datas, dateDepotPlainte: value.target.value })}}
              value={datas.dateDepotPlainte}
              required={true}
              placeholder="Date de dépôt de plainte (jj/mois/année)"
              name="dateDepotPlainte"
              className={"mt-1"}
              type="text"
            />

          </div>
          <div className={`d-flex justify-content-${!steps[0].isCurrent ? "between" : "end"} w-100`}>
            {!steps[0].isCurrent && (
              <Button
                        label={"Retour"}
                        onClick={() => handlePreviousStep()}
                        style={Button_Style.OUTLINED}
                    />
                )}
                <Button
                    label={"Suivant"}
                    onClick={() => handleNextStep()}
                />
            </div>
        </div>
    );
};

export default IDAssistantUploadPV;
